import _typeof from "@babel/runtime/helpers/typeof";

var getNestedValue = function getNestedValue(data, keyArr) {
  var currentIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (currentIndex === keyArr.length) {
    if (typeof data === 'string') {
      return data;
    }

    return null;
  }

  if (typeof data !== 'string') {
    return getNestedValue(data === null || data === void 0 ? void 0 : data[keyArr === null || keyArr === void 0 ? void 0 : keyArr[currentIndex]], keyArr, currentIndex + 1);
  }

  return null;
};

export var getI18nValue = function getI18nValue(data, key, getDefaultText) {
  var keyArr = key.split('.');
  var text = getNestedValue(data, keyArr);

  if (!text && getDefaultText) {
    return getDefaultText(key);
  }

  return text || key;
};
export default function createI18n() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentLang;
  var listenHandlers = [];

  if (data === null || _typeof(data) !== 'object') {
    throw new Error('React Simple I18n: Language data should be an object');
  }

  if (options === null || _typeof(options) !== 'object') {
    throw new Error('React Simple I18n: Options should be an object');
  }

  var lang = options.lang,
      getDefaultText = options.getDefaultText;
  var langData = data;
  currentLang = lang || (data.enUS ? 'enUS' : null);

  function t(key) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!currentLang) {
      throw new Error('React Simple I18n: Current language must be set before using t()');
    }

    if (!key || typeof key !== 'string') {
      throw new Error('React Simple I18n: t() must have string type as its first argument');
    }

    var value = getI18nValue(langData[currentLang], key, getDefaultText);

    if (args.length === 0) {
      return value;
    } else {
      var i = 0;
      return value.replace(/%s%/gi, function () {
        var output = args[i];
        i += 1;
        return typeof output !== 'undefined' ? output : '%s%';
      });
    }
  }

  function listen(handler) {
    listenHandlers.push(handler);
  }

  function unlisten(handler) {
    listenHandlers = listenHandlers.filter(function (func) {
      return handler !== func;
    });
  }

  function getLang() {
    return currentLang;
  }

  function setLang(lang) {
    if (lang === currentLang) return;

    if (!data[lang]) {
      return console.error("Language '".concat(lang, "' is not found."));
    }

    currentLang = lang;
    listenHandlers.forEach(function (func) {
      func({});
    });
  }

  function addLangData(data) {
    Object.assign(langData, data);
  }

  function _getListenHandlers() {
    return listenHandlers;
  }

  return {
    t: t,
    getLang: getLang,
    setLang: setLang,
    listen: listen,
    unlisten: unlisten,
    addLangData: addLangData,
    _getListenHandlers: _getListenHandlers
  };
}